  <template>
  <div>
    <a-card>
      <div :class="advanced ? 'search' : null">
        <a-form layout="horizontal">
          <div :class="advanced ? null : 'fold'">
            <a-row>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="材料认领表"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    v-model="params.materialId"
                    @change="search"
                  >
                    <a-select-option
                      v-for="item in materialList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="学院"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.studentCollege"
                    @change="loadSpecialty"
                  >
                    <a-select-option
                      v-for="item in collegeList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="专业"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.studentSpecialty"
                  >
                    <a-select-option
                      v-for="item in specialtyList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="状态"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.detailStatus"
                  >
                    <a-select-option
                      v-for="item in statusList"
                      :value="item.code"
                      :key="item.code"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="姓名/学号"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-input v-model="params.studentName" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <span style="float: right; margin-top: 3px">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="rest">重置</a-button>
            <a @click="toggleAdvanced" style="margin-left: 8px">
              {{ advanced ? "收起" : "展开" }}
              <a-icon :type="advanced ? 'up' : 'down'" />
            </a>
          </span>
        </a-form>
      </div>
      <a-divider></a-divider>

      <div>
        <div
          class="btn-group"
          style="display: flex; justify-content: space-between"
        >
          <div v-if="!host.includes('cup')"> 
            <a-button type="primary" :disabled="selectedStudentCodes.length<1" @click="openBathHandle"
              >批量办理
            </a-button>
            <a-button
              type="primary"
              style="margin-left: 8px"
              @click="importVisible = true"
              >导入办理
            </a-button>
          </div>
          <div v-else></div>
          <div>
            <a-button
              type="default"
              style="margin-left: 8px"
              icon="cloud-download"
              @click="downloadExcel"
              >导出</a-button
            >
          </div>
        </div>
        <a-table
          :loading="loading"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="pagination"
          :row-selection="{
            onChange: onTableRowSelectionChange,
            selectedRowKeys: selectedStudentCodes,
          }"
          rowKey="student_code"
        >
          <div slot="action" slot-scope="row">
            <a-button type="link" size="small" @click="onView(row)"
              >修改</a-button
            >
          </div>
          <template slot="statusTitle">
            <a-icon @click.native="onStatusTitleClick" type="info-circle" />
          </template>
        </a-table>
      </div>
    </a-card>
    <a-modal v-model="visible" title="修改信息" @ok="submit">
      <template v-if="currentItem">
        <div
          class="user-info"
          style="display: grid; grid-template-columns: 3fr 1fr"
        >
          <a-list :grid="{ gutter: 16, column: 2 }">
            <a-list-item>姓名: {{ currentItem.student_name }}</a-list-item>
            <a-list-item>学院: {{ currentItem.student_college }}</a-list-item>
            <a-list-item>学号: {{ currentItem.student_code }}</a-list-item>
            <a-list-item
              >专业: {{ currentItem.student_speciality }}</a-list-item
            >
            <a-list-item
              >联系电话: {{ currentItem.student_mobile }}</a-list-item
            >
            <a-list-item>班级: {{ currentItem.student_class }}</a-list-item>
          </a-list>
          <a-avatar :size="64" icon="user" />
        </div>
        <div>
          <ul class="radio-list">
            <li v-for="item in currentItem.materialDetails" :key="item.id">
              <span v-text="item.name"></span>
              <!-- <span v-text="statusMapper[item.status]"></span> -->

              <div v-if="item.type == 0">
                <a-radio-group :name="item.name" v-model="item.content">
                  <a-radio
                    v-for="sub in item.perms"
                    :key="sub.name"
                    :value="sub.name"
                  >
                    {{ sub.name }}
                  </a-radio>
                </a-radio-group>
              </div>
              <div v-else>
                <a-input v-model="item.content" placeholder="请输入名称" />
              </div>
            </li>
          </ul>
        </div>
        <a-divider></a-divider>
        <img
          v-if="currentItem.sign"
          class="sign-img"
          :src="currentItem.sign"
          alt=""
        />
        <a-empty v-else />
      </template>
    </a-modal>
    <a-modal v-model="batchVisible" title="批量办理" @ok="submitBatchStudentMaterial">
      <template v-if="currentItem">
        <div>
          <ul class="radio-list">
            <li v-for="item in currentItem.materialDetails" :key="item.id">
              <span v-text="item.name"></span>
              <!-- <span v-text="statusMapper[item.status]"></span> -->

              <div v-if="item.type == 0">
                <a-radio-group :name="item.name" v-model="item.content">
                  <a-radio
                    v-for="sub in item.perms"
                    :key="sub.name"
                    :value="sub.name"
                  >
                    {{ sub.name }}
                  </a-radio>
                </a-radio-group>
              </div>
              <div v-else>
                <a-input v-model="item.content" placeholder="请输入名称" />
              </div>
            </li>
          </ul>
        </div>
      </template>
    </a-modal>
    <!--  批量导入弹窗  -->
    <a-modal title="上传" v-model="importVisible" @ok="importStudentMaterial">
      <ol>
        <li>
          <p>
            下载模板，并按照模板中的使用说明填写信息，<span style="color: red">
              请勿更改表结构（如删除某行）</span
            >
          </p>
          <p>
            <a @click="downloadTemplateFile">下载《材料认领确认导入模板》</a>
          </p>
        </li>
        <li>
          <p>请选择填写完成的excel 文档</p>
          <a-form-model
            ref="uploadExcelRuleForm"
            :model="fileFrom"
            :rules="uploadExcelRules"
          >
            <a-form-model-item
              :labelCol="{ span: 0 }"
              :wrapperCol="{ span: 24 }"
              prop="fileName"
            >
              <c-upload
                name="file"
                :multiple="false"
                :action="uploadFileUri"
                acceptType="excel"
                @change="handleChange"
              >
                <div v-if="fileFrom.fileName">
                  <a-icon type="file-excel" />
                  <a v-text="fileFrom.fileName"></a>
                </div>
                <a-button v-else>
                  <a-icon :type="loadingFile ? 'loading' : 'plus'" />选择文件
                </a-button>
              </c-upload>
            </a-form-model-item>
          </a-form-model>
          <p>请上传格式为xls或xlsx的文件，最大支持30M</p>
        </li>
      </ol>
    </a-modal>
  </div>
</template>

<script>
import uploadFileUri from "@/services/uploadFileUri";
import * as service from "@/services/studentMaterial";
import { listCollege, listMajorDic } from "@/services/organization";
import { getTreeByCode } from "@/services/dict";
const columns = [
  {
    title: "材料认领表",
    dataIndex: "material_title",
  },
  {
    title: "学号",
    dataIndex: "student_code",
  },
  {
    title: "姓名",
    dataIndex: "student_name",
  },
  {
    title: "班级",
    dataIndex: "student_class",
  },
  {
    title: "专业",
    dataIndex: "student_speciality",
  },
  {
    title: "联系电话",
    dataIndex: "student_mobile",
  },
  {
    title: "状态",
    dataIndex: "deatil_status",
    customRender: (text) => {
      return statusMapper[text];
    },
  },
];
let statusMapper = {};
const dataSource = [];
const uploadExcelRules = {
  fileName: [{ required: true, message: "请选择文件", trigger: "change" }],
};
export default {
  name: "MaterialScienceManagement",
  data() {
    return {
      host:window.location.hostname,
      params: {
        pageNum: 1,
        pageSize: 10,
      },
      advanced: true,
      loading: false,
      columns: columns,
      dataSource: dataSource,
      pagination: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      visible: false,
      batchVisible: false,
      importVisible: false,
      currentItem: undefined,
      uploadExcelRules,
      uploadFileUri,
      loadingFile: false,
      fileFrom: {
        fileName: "",
      },
      selectedStudentCodes: [],
      materialList: [],
      collegeList: [],
      specialtyList: [],
      statusList: [],
    };
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    onStatusTitleClick() {
      this.$message.info("你点击了状态栏表头");
    },
    async onView(row) {
      this.currentItem = Object.assign({}, { ...row, sign: "" });
      // this.currentItem.avatar = await service.getAvatar(row.studentCode);
      let data = await service.getStudentMaterialByCode(row.student_code);
      let materialDetails = data.materialDetails;
      materialDetails.forEach((o) => {
        if (o.perms) {
          o.perms = JSON.parse(o.perms);
        }
      });
      this.$set(this.currentItem, "materialDetails", materialDetails);
      this.$set(
        this.currentItem,
        "sign",
        data.sign ? data.sign.sign : undefined
      );
      this.visible = true;
    },
    async submit() {
      let data = {
        studentCode: this.currentItem.student_code,
        studentMaterials: this.currentItem.materialDetails.map((o) => {
          return {
            detailId: o.id,
            status: o.content,
          };
        }),
      };
      await service.editStudentMaterial(data);
      this.$message.success("操作成功");
      this.visible = false;
      this.loadData();
    },
    async loadSpecialty(collegeId) {
      this.specialtyList = await listMajorDic(collegeId);
    },
    onPageChange(page) {
      this.params.pageNum = page;
      this.loadData();
    },
    async loadClos() {
      let res = await service.listCols(this.params.materialId);
      this.columns = [
        ...columns,
        ...res.map((o) => {
          o.dataIndex = o.key;
          return o;
        }),
        {
          title: "操作",
          scopedSlots: {
            customRender: "action",
          },
        },
      ];
    },
    async loadData() {
      this.dataSource = [];
      this.loading = true;
      const d = await service.findAll(this.params);
      this.loading = false;
      this.dataSource = d.records;
      this.pagination.current = d.current;
      this.pagination.total = d.total;
    },
    search() {
      console.log("search");
      this.loadClos();
      this.onPageChange(1);
    },
    rest() {
      this.params = {
        materialId: this.params.materialId,
        pageNum: 1,
        pageSize: 10,
      };
      this.onPageChange(1);
    },
    downloadExcel() {
      service.exportExcel(this.params);
    },
    handleChange(info) {
      console.log(info);
      if (info.file.status !== "uploading") {
        this.loadingFile = true;
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.loadingFile = false;
        this.fileFrom.filepath = info.file.response.data.filePath;
        this.fileFrom.fileName = info.file.name;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败.`);
      }
    },
    downloadTemplateFile() {
      service.downloadTemplateFile({ materialId: this.params.materialId });
    },
    async importStudentMaterial() {
      this.$refs.uploadExcelRuleForm.validate(async (valid) => {
        if (valid) {
          await service.importStudentMaterial({
            materialId: this.params.materialId,
            filepath: this.fileFrom.filepath,
          });
          this.importVisible = true;
          this.loadData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
   async openBathHandle() {
     let data = await service.getStudentMaterialByCode(this.dataSource[0].student_code);
      let materialDetails = data.materialDetails;
      materialDetails.forEach((o) => {
        o.content = undefined;
        if (o.perms) {
          o.perms = JSON.parse(o.perms);
        }
      });
      this.currentItem = Object.assign({});
      this.$set(this.currentItem, "materialDetails", materialDetails);
      this.batchVisible = true;
    },
    onTableRowSelectionChange(selectedRowKeys) {
      this.selectedStudentCodes = selectedRowKeys;
    },
    async submitBatchStudentMaterial() {
      let data = {
        studentCodes: this.selectedStudentCodes,
        materialId: this.params.materialId,
        studentMaterials: this.currentItem.materialDetails.map((o) => {
          return {
            detailId: o.id,
            status: o.content,
          };
        }),
      };
     await service.batchStudentMaterial(data);
      this.$message.success("操作成功");
      this.batchVisible = false;
      this.loadData();
    },
  },
  async mounted() {
    this.collegeList = await listCollege();
    this.materialList = await service.listMaterial();
    this.statusList = await getTreeByCode("LQZT");
    statusMapper = {};
    this.statusList.forEach((o) => {
      statusMapper[o.code] = o.name;
    });
    this.params.materialId = this.materialList[0].id;
    this.loadClos();
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
.radio-list {
  list-style: none;
  padding-inline-start: 0;

  > li {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 30px;
    padding: 15px;
  }
}

.sign-img {
  width: 100%;
  height: 200px;
  background: #eee;
}

.search {
  margin-bottom: 64px;
}

.fold {
  width: calc(100% - 216px);
  display: inline-block;
}

.operator {
  margin-bottom: 18px;
}

@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}
</style>
